import React, { useEffect, useState } from 'react'
import './new-reward-modal.styles.scss'

import Modal from '@/components/modal/modal.component'
import { useLocation, useNavigate } from 'react-router-dom'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { setNewStuffCount } from '@/state/slices/contentSlice'
import { properCase } from '@/utils/properCase'
import { UseCloudGameTransactions } from '@/utils/firebase.utils'
import { useDispatch, useSelector } from 'react-redux'

const NewRewardModal = ({ 
    gameData, 
    playerData, 
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ show, setShow ] = useState(null);
    const [ alertType, setAlertType ] = useState(null);
    const [ modalImage, setModalImage ] = useState(null);
    const [ modalText, setModalText ] = useState(null);
    const [ appliedElement, setAppliedElement ] = useState(null);
    const [ activityId, setActivityId ] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        if (!playerData) return;
        
        let savedNewRewardCount = 0;
        // let savedNewRewardCount = window.localStorage
        // .getItem(`${playerData.playerId}_newRewardCount`);
        // if (!savedNewRewardCount) {
        //     savedNewRewardCount = 0;
        //     window.localStorage.setItem(`${playerData.playerId}_newRewardCount`, 0);
        // }

        if (playerData.newStuff && playerData.newStuff.length > 0) {
            const rewardList = playerData.newStuff.filter(n => {
                if (
                    n.display === 'reward' ||
                    n.display === 'achievement' ||
                    n.display === 'prizepack' ||
                    n.display === 'purchase'
                ) return true;
            });
            dispatch(setNewStuffCount(rewardList.length));
            if (rewardList.length > savedNewRewardCount) {
                if (rewardList.filter(r => 
                        r.display === 'reward' &&
                        r.type === 'approvedItem'
                    ).length > 0
                ) {
                    let activity = rewardList.filter(r => 
                        r.display === 'reward' &&
                        r.type === 'approvedItem'
                    )[0];
                    setAlertType('approvedItemWithReward');
                    setAppliedElement(activity)
                }
                else if (rewardList.filter(r => 
                        r.type === 'approvedItem'
                    ).length > 0
                ) {
                    let activity = rewardList.filter(r => 
                        r.type === 'approvedItem'
                    )[0];
                    setAlertType('approvedItem');
                    setActivityId(activity.id);
                    setAppliedElement(activity);
                }
                else if (rewardList.filter(r => 
                        r.display === 'reward' &&
                        r.type === 'secretCode'
                    ).length > 0
                ) {
                    let activity = rewardList.filter(r => 
                        r.display === 'reward' &&
                        r.type === 'secretCode'
                    )[0];
                    // console.log(activity);
                    setAppliedElement(activity);
                    setAlertType('codeWithReward');
                }
                else if (rewardList.filter(r =>
                        r.display === 'reward'
                    ).length > 0
                ) {
                    setAlertType('rewardWithReward')
                }
                else if (rewardList.filter(r => 
                        r.display === 'achievement'
                    ).length > 0
                ) {
                    setAlertType('achievementWithReward');
                } 
                else if (rewardList.filter(r => 
                        r.display === 'prizepack'
                    ).length > 0
                ) {
                    setAlertType('prizepackWithReward');
                }
                else if (rewardList.filter(r => 
                        r.display === 'purchase' &&
                        r.type === 'purchase'
                    ).length > 0
                ) {
                    let activity = rewardList.filter(r => 
                        r.display === 'purchase' &&
                        r.type === 'purchase'
                    )[0];
                    setActivityId(activity?.id);
                    setAlertType('purchaseComplete');
                }
                return;
            }
        }
        
    }, [playerData])

    useEffect(() => {
        if (
            alertType === 'approvedItem' ||
            alertType === 'approvedItemWithReward'
        ) {
            setModalImage(appliedElement ? appliedElement.icon : null);
            setModalText('An item you submitted has been ACCEPTED!');
            setShow(true);
        } else if (alertType === 'codeWithReward') {
            setModalImage(appliedElement ? appliedElement.icon : null);
            setModalText('You found a secret code!');
            setShow(true);
        }
        else if (alertType === 'rewardWithReward') {
            setModalImage('/images/icons/treasure-cl.png');
            setModalText('You have New Rewards to Discover!');
            setShow(true);
        } else if (alertType === 'achievementWithReward') {
            setModalImage('/images/icons/achievement_frame.gif');
            setModalText('You have New Achievements!<br />Check out what you have earned.');
            setShow(true);
        } else if (alertType === 'prizepackWithReward') {
            setModalImage('/images/icons/prizepack_frame.gif');
            setModalText('You Have New Prize Packs to Open!');
            setShow(true);
        } else if (alertType === 'purchaseComplete') {
            setModalImage('/images/icons/shopping-cart.png');
            setModalText('Your Purchase is Complete!');
            setShow(true);
        }
        
    }, [alertType, appliedElement])

    function goToRewards() {
        // window.localStorage.setItem(
        //     `${playerData.playerId}_newRewardCount`, 
        //     playerData.newStuff.length
        // );
        setShow(null);
        navigate(`/play/${gameData.path}/rewards`);
    }

    function setLater(e) {
        // window.localStorage.setItem(
        //     `${playerData.playerId}_newRewardCount`, 
        //     playerData.newStuff.length
        // );
        setShow(null);
    }

    async function handleOk() {
        const data = {
            'gameId': gameData.gameId,
            'playerId': playerData.playerId,
            'rewardIdArr': [activityId]
        }
        if (!location.pathname.includes('/preview/player/')) {
            const res = await UseCloudGameTransactions('markRewardAsViewed', data);    
            console.log(res);
        }
        setShow(false);
        // window.localStorage.setItem(
        //     `${gameData.gameId}_newRewardCount`, 
        //     playerData.newStuff.length
        // );
    }

    return (
        <div>
            <Modal 
                show={show} 
                cancel={() => setShow(null)} 
                cls={
                    screenSize === 'mobile' 
                    ? 'full' 
                    : screenSize === 'tablet' ?
                    '' :
                    'narrow'
                }>
                <div className={`modal-children new-reward-modal ${screenSize}`}>
                    <ImageContainer 
                        src={modalImage} 
                        alt='reward notification icon' 
                        className='treasure-gif' />
                    <h2>
                        <div dangerouslySetInnerHTML={{__html: modalText}}></div>
                    </h2>
                    <hr />
                    {
                        (alertType && alertType.includes('WithReward'))
                        ?
                        <div className="buttons">
                            {/* <button 
                                className={`g-button ${
                                    screenSize === 'mobile' 
                                    ? 'med-btn' 
                                    : ''
                                }`} 
                                onClick={() => setLater()}>
                                Later
                            </button> */}
                            <button 
                                className={`g-button primary ${
                                    screenSize === 'mobile' 
                                    ? 'med-btn' 
                                    : ''
                                }`} 
                                onClick={() => goToRewards()}>
                                Go to My Rewards!
                            </button>
                        </div>
                        :
                        <div className="buttons">
                            <button 
                                className={`g-button primary ${
                                    screenSize === 'mobile' 
                                    ? 'med-btn' 
                                    : ''
                                }`} 
                                onClick={() => handleOk()}>
                                Ok
                            </button>
                        </div>
                    }
                </div>
            </Modal>
        </div>
    )
}

export default NewRewardModal